import { render, staticRenderFns } from "./SingleFileUpload.vue?vue&type=template&id=2316ec9c&scoped=true&"
import script from "./SingleFileUpload.vue?vue&type=script&lang=js&"
export * from "./SingleFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2316ec9c",
  null
  
)

export default component.exports